let script_loaded=false;

if(void 0===uLTS){var uLTS=new MutationObserver(e=>{});
uLTS.observe(document.documentElement,{childList:!0,subtree:!0})}

const loadLinks = (e) => {
  null!=(datahref=e.dataset.href)&&(e.href=datahref)
}

const loadIFrame = (e) => {
  null!=(datasrc=e.dataset.src)&&(e.src=datasrc);
  e.classList.add('iframe-loaded');
}

const loadVideo = (e) => {
  null!=(datasrc=e.dataset.src)&&(e.src=datasrc);
  e.classList.add('video-loaded');
  if (e.dataset.html) e.innerHTML = e.dataset.html;
}

function loadScript(e) {
  var t=document.createElement("script");
  
  for(a=0;a<e.attributes.length;a++){var r=e.attributes[a];t.setAttribute(r.name,r.value)}
  
  t.innerHTML=e.innerHTML;

  if (e.dataset.src){
    t.src = e.dataset.src;
  }
  
  if (e.dataset.type){
    t.type = e.dataset.type;
  } else {
    t.type="text/javascript";
  }

  e.parentNode.insertBefore(t,e);
  e.parentNode.removeChild(e);
}

function loadJSscripts(){
  if (!script_loaded){
    void 0!==uLTS && uLTS.disconnect()
    script_loaded=true
  
    document.querySelectorAll("link[data-href]").forEach(loadLinks)
    document.querySelectorAll("script[type='text/lazyload']").forEach(loadScript)
    document.querySelectorAll("iframe[data-src]").forEach(loadIFrame)
    
    if (!__isPSA) {
      setTimeout(function(){  
        document.dispatchEvent(new CustomEvent("asyncLazyLoad"))
        document.dispatchEvent(new CustomEvent("loadBarInjector"))
      }, 1000)
    }
  }
}

function observeVideo(entries) {
  entries.forEach((entry) => {
    if (entry.isIntersecting && !entry.target.classList.contains('video-loaded')) {
      loadVideo(entry.target);
    }
  })
}

function observeIframe(entries) {
  entries.forEach((entry) => {
    if (entry.isIntersecting && !entry.target.classList.contains('iframe-loaded')) {
      loadIFrame(entry.target);
    }
  })
}

function initVideoObserver(){
  if ( typeof IntersectionObserver === 'function' ) {
    const options = {
      root: null,
      rootMargin: '120px',
      threshold: [0.025, 0.1]
    }

    const observer = new IntersectionObserver((e) => observeVideo(e), options)
    
    document.querySelectorAll('video').forEach(el => {
      observer.observe(el)
    })

    const iframeObserver = new IntersectionObserver((e) => observeIframe(e), options)
    
    document.querySelectorAll('iframe[data-src]').forEach(el => {
      iframeObserver.observe(el)
    })
    
  } else {
    document.querySelectorAll('video').forEach(loadVideo)
    document.querySelectorAll("iframe[data-src]").forEach(loadIFrame)
  }
}

(function(){
  (__isPSA)?["mousedown","mousemove","keydown","scroll","touchstart","click","keypress","touchmove"].forEach(function(e){
      window.addEventListener(e,loadJSscripts,!1)
  }):loadJSscripts();
})()

initVideoObserver();